 <template>
    <div style="background:white; height:100%">
        <div style=" display:flex; min-width:1200px; background:#fff;line-height:40px; border-bottom:2px solid #389;">
            <div style="display:flex;padding-top:3px;text-align:center">
                <div style="font-size:12px;margin-right:5px;margin-left:5px;font-weight:600;color:#389">年份</div>
                <el-select v-model="v_year" @change="qryTabData" placeholder="请选择"  filterable  size="small" style="width:90px; ">
                    <span v-for="item in yrArr" :key='item.key' >
                        <el-option :label="item.CNAME" :value="item.CODE"  ></el-option>
                    </span>
                </el-select>
                <div style="font-size:12px;margin-right:5px;margin-left:15px;font-weight:600;color:#389">供应商名称</div>
                <el-select v-model="v_supno" @change="qryTabData" placeholder="请选择" multiple collapse-tags clearable filterable size="small" style="width:300px; "> 
                    <span v-for="(item,index) in supArr" :key='index' >
                        <el-option :label="item.SUPNM" :value="item.SUPNO"  ></el-option>
                    </span>
                </el-select> 
                <div style="font-size:12px;margin-right:5px;margin-left:15px;font-weight:600;color:#389">排序方式</div>
                <el-select v-model="v_sort" @change="qryTabData" placeholder="请选择"  filterable  size="small" style="width:160px; "> 
                    <el-option label="默认供应商排序" value=" order by supnm"  ></el-option> 
                    <el-option label="以合计采购金额升序" value=" order by ttlamt"  ></el-option>
                    <el-option label="以合计采购金额降序" value=" order by ttlamt desc"  ></el-option>
                </el-select> 
                <div style="font-size:12px;line-height:20px; margin-left:15px;font-weight:600;color:#289;display:flex;flex-direction:column"> 
                    <div >说明：金额占比% = 指供应商当月采购金额/供应商年度总采购金额</div>
                    <div >合计占比% = 供应商年度总采购金额/年度总采购金额</div>
                </div>
                <!-- <el-dropdown @command="dropSel" split-button type="primary" size="small" style="margin-left:10px">更多功能
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">导出数据</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
        </div> 
        <el-table  :data="tabData" 
                border                            
                disabled-hover
                class="custom-table-border"
                :header-cell-style="headStyle"
                size="small"
                ref="tabref"
                :cell-class-name="cellRowClass"
                v-loading="v_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                :height="tabHeight" 
                show-summary
                :summary-method="getSummary"
                highlight-current-row>
            <el-table-column type="index" label="序号" width="60" fixed></el-table-column>
            <!-- <el-table-column fixed prop="SUPNO" label="编码" show-overflow-tooltip align="left" min-width="60"> </el-table-column>  -->
            <el-table-column fixed prop="SUPNM" label="供应商名称" show-overflow-tooltip align="left" min-width="160"> </el-table-column> 
            <el-table-column label="一月" align="center" style="background:white" prop="ONETOP">  
                <el-table-column  prop="AMT01" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'01',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT01']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT01" label="金额占比%" show-overflow-tooltip align="right" min-width="58" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="二月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT02" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'02',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT02']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT02" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="三月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT03" label="采购金额" show-overflow-tooltip align="right" min-width="80">
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'03',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT03']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT03" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column> 
            </el-table-column>    
            <el-table-column label="四月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT04" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'04',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT04']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT04" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column> 
            <el-table-column label="五月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT05" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'05',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT05']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT05" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="六月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT06" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'06',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT06']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT06" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="七月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT07" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'07',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT07']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT07" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column> 
            </el-table-column>
            <el-table-column label="八月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT08" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'08',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT08']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT08" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="九月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT09" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'09',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT09']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT09" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="十月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT10" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'10',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT10']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT10" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column>
            </el-table-column>
            <el-table-column label="十一月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT11" label="采购金额" show-overflow-tooltip align="right" min-width="80"> 
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'11',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT11']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT11" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column> 
            </el-table-column> 
            <el-table-column label="十二月" align="center" style="background:white" prop="ONETOP">
                <el-table-column  prop="AMT12" label="采购金额" show-overflow-tooltip align="right" min-width="80">
                    <template slot-scope="scope"><el-link :underline="false" @click="ordList(v_year,'12',scope.row['SUPID'])"><span style="border-bottom:1px solid red;font-size:12px">{{scope.row['AMT12']}}</span></el-link></template>
                </el-table-column> 
                <el-table-column  prop="PCT12" label="金额占比%" show-overflow-tooltip align="right" min-width="60" style="font-size:12px"> </el-table-column> 
            </el-table-column>
            <el-table-column label="合计" align="center" style="background:white">
                <el-table-column  prop="TTLAMT" label="采购金额" show-overflow-tooltip align="right" min-width="90"> </el-table-column> 
                <el-table-column  prop="TTLPCT" label="合计占比%" show-overflow-tooltip align="right" min-width="58" style="font-size:12px"> </el-table-column> 
            </el-table-column>                              
        </el-table>

        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog  v-dialogDrag   :visible.sync="dtlWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">明细记录</span>
            </div> 
            <pub-dialog v-bind:tabCol ="tabArr" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_cond="v_cond_"  @child-exit="dtlWin=false"  ></pub-dialog>                
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
import pubDialog from '../datamgt/pubdialog.vue' 
//局部注册
export default {
    name:"po_analyze",
    data () {
        return {
            v_rmk:'',
            repDlg:false,
            dtlWin:false,
            v_cond_:'',
            repUrl:'',
            setWin:false,
            v_supno:[] ,
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            mainRow:{},
            yrArr: [],
            v_loading:false,
            supArr:[],
 
            disabled:false, //新增权限制
            v_sort:' order by ttlamt desc',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
 
            tabData:[], //表数据
 
 
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'SMPNO',
            selparam2:'',
            oper2:'like',
            txtparam2:'',
            findWin:false,
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            v_year:'',
 
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            operArr:[],
            initCol:[] , //初始化列
 
            fldArr:[],
            setRow:{},
            uploadData:{}, //上传数据
            videoFlag:false,
            tabArr:[],
 
            v_saveFlag:true,
            v_idno:'',
            v_replist:[],
 
            v_value2:'',
            v_key2:'',
            v_index:'',
            v_random:'',
            tableCol:[],
            v_table:'',
            v_key:'',
 
            btnWin:false,
 
        }
    },
    mounted () { 
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','400143','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_PO_SUP',' order by supno').then(res=>{
            this.supArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','corpid',this.v_corpid,'','','V_PO_YEAR','').then(res=>{
            this.yrArr =res.result
            this.v_year =getDate('yr')
            this.qryTabData()
        })
        this.getTabField()
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 150) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 120) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    components: {
        pubDialog,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            
 
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        // 明细查看
        ordList(v_year,v_month,v_supID){
            //console.log(v_year,v_month,v_supno)
            this.v_table ='V_PO_DTLREP'
            this.v_random='item'+Math.random()
            this.v_cond_ =' AND supno=\''+v_supID+'\' and substr(orddttm,1,7)=\''+v_year+'-'+v_month+'\''
            this.dtlWin =true
        },
        cellRowClass({row,column,rowIndex,columnIndex}){  //为 table数据添加 index 字段
            if (column.property=='AMT01'||column.property=='AMT02'||column.property=='AMT03'||column.property=='AMT04'||column.property=='TTLPCT'
               ||column.property=='AMT05'||column.property=='AMT06'||column.property=='AMT07'||column.property=='AMT08' 
               ||column.property=='AMT09'||column.property=='AMT10'||column.property=='AMT11'||column.property=='AMT12'){
                return 'red-cell'
            }else{
                return 'black-cell'
            }
        },
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property.indexOf('AMT')>-1||column.property.indexOf('QTY')>-1){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ) 
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        headStyle({row,column}){
            if (column.property=='ONETOP'  ){
                return 'color:red;background:#c7c8c9 '
            }else{
                return 'color:#0C090A;background:#c7c8c9 '
            }
        },
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                let cond_=[]
                cond_.push(this.selparam)
                cond_.push(this.oper)
                cond_.push(this.txtparam)  
                let url='xuper_auth/report/ExpExcel'+'&p_key=corpid&p_value='+this.v_corpid+'&p_idseq=400143&p_lstseq=1&p_table=V_SMP_JOBQRY&p_cond='+cond_+'&p_filenm=样办工序明细表'
                window.open(url)
            } 
        },
 
        //查询明细
        getTabList(cond){ 
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond +this.v_sort,p_table:'V_SUP_POQRY'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                    // let v_sum =0
                    // res.result.forEach(item=>{
                    //     if (item['TTLAMT']){
                    //         v_sum =Number(v_sum) +Number(item['TTLAMT'])
                    //     }
                    // })                   
                    // res.result.forEach(item=>{
                    //     if (v_sum >0){
                    //         this.tabData.push(Object.assign(item,{AMTPCT: (Number(item['TTLAMT'])/v_sum *100).toFixed(2)}))
                    //     }else{
                    //         this.tabData.push(Object.assign(item,{AMTPCT: ''}))
                    //     }
                    // })
 
                    this.v_loading =false
                    this.$nextTick(()=>{
                        this.$refs['tabref'].doLayout()
                    })
                }else{
                    this.v_loading =false
                    this.promptWin=true
                    this.prompt=res.result
                }               
            }) 
        },
 
        //查询
        qryTabData(){
            let v_cond =' and yr=\''+this.v_year+'\''
            if (this.v_supno.length>0){
                const v_supList =this.v_supno.map(item=>`'${String(item).replace(/'/g,"''")}'`).join(',')
                v_cond =v_cond+' and supID in ('+v_supList+')'
            }
            this.getTabList(v_cond)
        },
        //422120
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','422120','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-row {
        width: 97%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .el-table .red-cell  {
        color: rgb(155, 39, 184);
        font-weight: bolder;
        font-size:11px;
    }
    .el-table .black-cell  {
        font-weight: 600;
        font-size:11px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 